import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConnectionService } from '../../connection.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
	lower = true; upper = true; loginToken = ""; loginVerify = ""; len = true; num = true; spec = true; signLoader = false; captchaVal = false; captcha = ""; usrmail = false; isShow = true; isShow1 = true;
	icon = "fa fa-eye-slash"; icon1 = "fa fa-eye-slash";
	modalRef: NgbModalRef;
	keyObj: any = {};
	fileUrl: any;
	address: any;
	tokenBalance: any;
	authEmail: any = {}
	model:any = {}

	constructor(private conn: ConnectionService, private alert: ToastrService, private route: Router, private actRoute: ActivatedRoute, private modalService: NgbModal, private sanitizer: DomSanitizer,
	) {
		if (actRoute.snapshot.url[0].path == 'activate_account') {
			this.actRoute.params.subscribe((params) => {
				this.loginToken = this.actRoute.snapshot.queryParamMap.get('token');
				this.loginVerify = this.actRoute.snapshot.queryParamMap.get('verify');
				if (this.loginToken == null || this.loginToken == undefined || this.loginToken == "undefined") {
					this.alert.error("Invalid request");
					this.route.navigate(['login']);
				} else if (this.loginVerify == null || this.loginVerify == undefined || this.loginVerify == "undefined") {
					this.alert.error("Invalid request");
					this.route.navigate(['login']);
				} else {
					this.conn.postUrl('users/activateEmail', { 'token': this.loginToken, 'verify': this.loginVerify }).subscribe((res: any) => {
						if (res.status == 1) {
							this.alert.success(res.msg);

						} else if (res.status == 3) {
							this.alert.error(res.msg);
						} else {
							this.alert.error(res.msg);
						}
						this.route.navigate(['login']);
					});
				}
			});
		}
	}

	ngOnInit() {

	}

	naivagteExplorer(){
		this.route.navigate(['/explorer'])
	}

	typePwd(pwd) {
		if (pwd != null && pwd != undefined && pwd != "") {
			this.lower = true; this.upper = true; this.len = true; this.num = true; this.spec = true;
			let lowerChars = /[a-z]/g;
			let upperChars = /[A-Z]/g;
			let numbers = /[0-9]/g;
			let specials = /\W|_/g;
			if (pwd.length < 8) { this.len = false; return; }
			if (pwd.match(lowerChars) == null) { this.lower = false; return; }
			if (pwd.match(upperChars) == null) { this.upper = false; return; }
			if (pwd.match(numbers) == null) { this.num = false; return; }
			if (pwd.match(specials) == null) { this.spec = false; return; }
		}
	}

	resolved(res: string) {
		if (res != "") {
		}
	}
	openbannermodel(content: any) {
		if(this.keyObj.loginStatus != null){
			setTimeout(() => {
				if (this.keyObj.loginStatus == false) {
					this.modalRef = this.modalService.open(content, { size: 'lg' });
					this.downloadFile(this.keyObj.privateKey)
				}
				else {
					this.route.navigateByUrl('explorer');
				}
			}, 3000)
		}

	}

	showPass() {
		this.isShow = (this.isShow) ? false : true;
		this.icon = (this.isShow) ? "fa fa-eye-slash" : "fa fa-eye";
	}

	submitFunc(login: NgForm) {
		var data = login.value;
		this.captcha = "";
		this.signLoader = true;
		if (localStorage.getItem('Sastana_Token')) {
			alert('You are already logged in')
		}
		else if (localStorage.getItem('Sastana_Token') == null) {
			this.conn.postUrl('users/login', data).subscribe((res: any) => {
				if (res.status == 2) {
					localStorage.setItem('userId', res.userId);
					localStorage.setItem('login', res.loginStatus);
					this.alert.success(res.msg)
					// localStorage.setItem('Address', res.address);
					// this.conn.setPrivateKey.emit(res.eky)
					// 					this.alert.success(res.msg);
					this.route.navigateByUrl('otp');
				}
				else if (res.status == 0) {
					this.alert.error(res.msg);
					// this.route.navigate(['/login']);
					this.route.navigateByUrl('otp');
				} else {
					this.alert.error(res.msg);
					// this.route.navigate(['login']);
					this.route.navigateByUrl('otp');
				}
				login.resetForm();
				this.signLoader = false;
			});
		}
	}

	pvtLogFunc(pvtLog: NgForm) {
		var data = pvtLog.value;
		this.captcha = "";
		this.signLoader = true;
		this.conn.postUrl('users/pkLogin', { value: data.pvtkey }).subscribe((res: any) => {
			if (res.status == true) {
				this.address = res.address
				localStorage.setItem('Sastana_Token', res.token);
				localStorage.setItem('Address', res.address);
				this.alert.success(res.message);
				this.route.navigateByUrl('explorer');
				this.getTokenBalance()

			} else if (res.status == false) {
				this.alert.error(res.message);
				this.route.navigate(['login']);
			} else {
				this.alert.error(res.message);
			}
			pvtLog.resetForm();
			this.signLoader = false;
		});
	}

	getTokenBalance() {
		this.conn.postUrl('contract/getBalance', { address: this.address }).
			subscribe((result: any) => {
				this.tokenBalance = result.data.Balance
				this.conn.tokenBalance.emit(this.tokenBalance)
			})
	}

	removeSpace(event: any) {
		if (event.code === 'Space') {
			event.preventDefault();
		}
	}

	copyText(val: string) {
		let selBox = document.createElement('input');
		selBox.value = val;
		document.body.appendChild(selBox);
		selBox.focus();
		selBox.select();
		document.execCommand('copy');
		document.body.removeChild(selBox);
		window.scrollTo(0, 0);
		this.alert.success('Copied to the clipboard');
	}

	checkLoginStatus() {
		this.conn.postUrl('users/loginStatus', { address: this.keyObj.address }).subscribe((res) => {
			if (res) {
				this.route.navigateByUrl('explorer');
			}
		})
	}

	downloadFile(data: any) {
		const blob = new Blob([data], { type: 'application/octet-stream' });
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.style.display = 'none';
		a.href = url;
		a.download = 'pvtkeyfile.txt';
		document.body.appendChild(a);
		a.click();
		window.URL.revokeObjectURL(url);
		document.body.removeChild(a);
	}

}
